// extracted by mini-css-extract-plugin
module.exports = {"_legende":"ModifikationsstatusLegende__legende__38CJY"};